import React from 'react';
import { Scissors, Armchair, Wallet } from 'lucide-react';
export function FeaturesSection() {
  return <section className="py-16 px-4 bg-white" data-id="element-26">
      <div className="max-w-6xl mx-auto" data-id="element-27">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 lg:gap-16" data-id="element-28">
          {/* Feature 1 */}
          <div className="group" data-id="element-29">
            <div className="w-11 h-11 flex items-center justify-center border border-[#C9A96E]/30 rounded-full mb-5 group-hover:bg-[#FAF7F2] transition-colors duration-300" data-id="element-30">
              <Scissors className="w-5 h-5 text-[#C9A96E]" data-id="element-31" />
            </div>
            <h3 className="text-xl font-serif text-[#1C1C1C] mb-3 group-hover:text-[#C9A96E] transition-colors duration-300" data-id="element-32">
              Cortinas con Poder
            </h3>
            <p className="text-[#1C1C1C]/70 leading-relaxed font-light text-sm md:text-base" data-id="element-33">
              Aprende a instalar pesos de plomo invisibles para que tu tela
              caiga como una columna de mármol. Un dobladillo de 10cm cambia
              totalmente la percepción de altura.
            </p>
          </div>

          {/* Feature 2 */}
          <div className="group" data-id="element-34">
            <div className="w-11 h-11 flex items-center justify-center border border-[#C9A96E]/30 rounded-full mb-5 group-hover:bg-[#FAF7F2] transition-colors duration-300" data-id="element-35">
              <Armchair className="w-5 h-5 text-[#C9A96E]" data-id="element-36" />
            </div>
            <h3 className="text-xl font-serif text-[#1C1C1C] mb-3 group-hover:text-[#C9A96E] transition-colors duration-300" data-id="element-37">
              Cojines de Lujo
            </h3>
            <p className="text-[#1C1C1C]/70 leading-relaxed font-light text-sm md:text-base" data-id="element-38">
              Domina el cierre invisible y el relleno 'over-stuffed' que no se
              deforma. El secreto de las tiendas de Beverly Hills para esa forma
              perfecta.
            </p>
          </div>

          {/* Feature 3 */}
          <div className="group" data-id="element-39">
            <div className="w-11 h-11 flex items-center justify-center border border-[#C9A96E]/30 rounded-full mb-5 group-hover:bg-[#FAF7F2] transition-colors duration-300" data-id="element-40">
              <Wallet className="w-5 h-5 text-[#C9A96E]" data-id="element-41" />
            </div>
            <h3 className="text-xl font-serif text-[#1C1C1C] mb-3 group-hover:text-[#C9A96E] transition-colors duration-300" data-id="element-42">
              Presupuesto Inteligente
            </h3>
            <p className="text-[#1C1C1C]/70 leading-relaxed font-light text-sm md:text-base" data-id="element-43">
              Te enseño a elegir telas de $5 que, con el tratamiento adecuado,
              engañan al ojo más experto pareciendo sedas de $100.
            </p>
          </div>
        </div>
      </div>
    </section>;
}